module.exports = __webpack_public_path__ + "media/images/arrow_down-2bf6622c.svg";